import { createTranslationService } from '@services/factories';
import { cacheTranslations } from '@utils/cache-translations';

export enum DocumentDetailsListTranslation {
    listADocumentTypePlaceholder = 'listADocumentTypePlaceholder',
    listBDocumentTypePlaceholder = 'listBDocumentTypePlaceholder',
    listCDocumentTypePlaceholder = 'listCDocumentTypePlaceholder',
    issuingAuthorityPlaceholder = 'issuingAuthorityPlaceholder',
    documentNumberPlaceholder = 'documentNumberPlaceholder',
    expiryDatePlaceholder = 'expiryDatePlaceholder',
    noExpirationDateLabel = 'noExpirationDateLabel',
    documentTitleLabel = 'documentTitleLabel',
    issuingAuthorityLabel = 'issuingAuthorityLabel',
    documentNumberLabel = 'documentNumberLabel',
    expirationDateLabel = 'expirationDateLabel',
    listA = 'listA',
    listAHeading = 'listAHeading',
    or = 'or',
    listB = 'listB',
    listBHeading = 'listBHeading',
    and = 'and',
    listC = 'listC',
    listCHeading = 'listCHeading',
    example = 'example',
    additionalInformation ='additionalInformation'
}

const translationContext = 'documentDetailList';

export const getDocumentDetailsListTranslations = () => cacheTranslations(
    createTranslationService(),
    DocumentDetailsListTranslation,
    translationContext
);



// WEBPACK FOOTER //
// ./src/containers/form-i9/document-details-list/translations.ts